jQuery(function($) {
    $(".nav li").click(function() {
        $(this).addClass('active').siblings().removeClass('active');
        $(document).on("click", function(event){
            var $trigger = $(".nav li");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $(".nav li").removeClass("active");
            }            
        });
    });
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".header, .nav_mobiles").addClass("header_background_active");
        } else {
            $(".header, .nav_mobiles").removeClass("header_background_active");
        }
    });
    $(".nav_mobiles .button_menu").click(function() {
        $nav =  $('.nav_mobiles .nav');
        $main = $('.wrapper_god');
        if($(this).hasClass('button_active')){
            $(this).removeClass('button_active');
            $($nav).removeClass('nav_active');
            $($main).removeClass('nav_active');
        } else {
            $(this).addClass('button_active')
            $($nav).addClass('nav_active');
            $($main).addClass('nav_active');
        }
    });
    $(window).scroll(function() {                  // assign scroll event listener
        var fixmeTop = $('.scroll_detect').offset().top;   // get initial position of the element
        var currentScroll = $(window).scrollTop() - 25; // get current position
        var fixmeBottom = $('.footer').offset().top - 550;   // get initial position of the element
        if (currentScroll >= fixmeTop) {           // apply position: fixed if you
            $('.fixme').addClass('fixed');
        } else {                                   // apply position: static
            $('.fixme').removeClass('fixed');
        }
        if (currentScroll >= fixmeBottom) {           // apply position: fixed if you
            $('.fixme').addClass('absoluted');
        } else {
            $('.fixme').removeClass('absoluted');
        }
    });
    $(window).load(function(){
        $('a[href*="#"]').on('click', function(e) {
            e.preventDefault()
            var extraOffset = 100;
            $('html, body').animate(
              { scrollTop: $($(this).attr('href')).offset().top - extraOffset,}, 800,'linear'
            )
          })
    });
});
